import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: { requiresAuth: false, debug: true } // 保持不需要认证
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('@/views/about/about.vue'),
        meta: { requiresAuth: false, debug: true }
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('@/views/contact/contact.vue'),
        meta: { requiresAuth: false, debug: true }
    },
    {
        path: '/join',
        name: 'join',
        component: () => import('@/views/join/join.vue'),
        meta: { requiresAuth: false, debug: true }
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('@/views/index/index.vue'),
        meta: { requiresAuth: false, debug: true }
    }
]

const router = new VueRouter({
    routes
})

// 保留调试日志但移除认证检查调用
router.beforeEach((to, from, next) => {
    console.group('🔄 路由守卫调试')
    console.log('当前路径:', to.fullPath)
    console.log('来源路径:', from.fullPath)
    console.log('是否需要认证:', to.meta.requiresAuth)
    console.log('localStorage.isLogin:', localStorage.getItem('isLogin'))
    console.log('localStorage.toLogin:', localStorage.getItem('toLogin'))
    console.log('redirect参数:', to.query.redirect)
    console.groupEnd()

    // 直接调用next()，不再触发可能导致跳转的认证检查
    next()
})

export default router